export default {
  notSpam: 'Not spam',
  restoreEmail: 'Restore',
  toastEmailRestoreRequested: 'Restore requested',
  toastEmailRestoreFailed: {
    one: 'Could not restore {{count}} email. Try again.',
    other: 'Could not restore {{count}} emails. Try again.',
  },
  // Action labels shared by the entity menus, file menu, command menu and
  // project/folder menus.
  markDone: 'Mark Done',
  markNotDone: 'Mark Not Done',
  markRead: 'Mark Read',
  markUnread: 'Mark Unread',
  open: 'Open',
  openInNewSplit: 'Open in new split',
  openInCurrentSplit: 'Open in current split',
  openFullscreen: 'Open fullscreen',
  rename: 'Rename',
  setChannelPicture: 'Set channel picture',
  removeChannelPicture: 'Remove channel picture',
  favorite: 'Favorite',
  unfavorite: 'Unfavorite',
  removeFromFavorites: 'Remove from favorites',
  addToFavorites: 'Add to favorites',
  archive: 'Archive',
  unarchive: 'Unarchive',
  // An agent session's auto-archive overrides.
  archiveWhenPullRequestsMerge: 'Archive when PRs merge',
  archiveWhenSessionCloses: 'Archive when session closes',
  autoArchiveUseDefaultOn: 'Use default (On)',
  autoArchiveUseDefaultOff: 'Use default (Off)',
  autoArchiveOn: 'On',
  autoArchiveOff: 'Off',
  openOnGitHub: 'Open on GitHub',
  viewItemsWithTag: 'View all items with tag',
  editTag: 'Edit tag',
  removeTag: 'Remove tag',
  snoozeNotifications: 'Snooze notifications…',
  muteNotifications: 'Mute notifications',
  unmuteNotifications: 'Unmute notifications',
  remindMe: 'Remind me',
  addTag: 'Add tag',
  addToProject: 'Add to project…',
  openProjectNamed: 'Open project {{name}}',
  changeProject: 'Change project',
  moveToFolder: 'Move to folder',
  removeFromFolder: 'Remove from folder',
  duplicate: 'Duplicate',
  copyLink: 'Copy Link',
  copyBranchName: 'Copy Branch Name',
  // Command-menu and tooltip wording (sentence case)
  markDoneCommand: 'Mark done',
  markReadCommand: 'Mark read',
  markUnreadCommand: 'Mark unread',
  discardDraftCommand: {
    one: 'Discard draft',
    other: 'Discard drafts',
  },
  copyLinkCommand: 'Copy link',
  copyBranchNameCommand: 'Copy branch name',
  copyId: 'Copy ID',
  share: 'Share',
  downloadDocx: 'Download',
  downloadEml: 'Download .eml',
  downloadEmlFailed: 'Failed to download email. Please try again.',
  senderToSignal: 'Sender → Signal',
  senderToNoise: 'Sender → Noise',
  blockSender: 'Block Sender',
  delete: 'Delete',
  setStatus: 'Set status',
  setPriority: 'Set priority',
  setAssignee: 'Set assignee',
  setStage: 'Set stage',
  setOwner: 'Set owner',
  setRevenue: 'Set revenue',
  openPropertyEditor: 'Open property editor',

  // Command menu wording that differs from the menu labels.
  markAsNotDone: 'Mark as not done',
  deleteItem: 'Delete item',
  deleteItems: 'Delete items',
  renameItem: 'Rename item',
  renameItems: 'Rename items',
  duplicateItem: 'Duplicate item',
  duplicateItems: 'Duplicate items',
  moveItemsToFolder: 'Move items to folder',
  tagItem: 'Tag item',
  tagItems: 'Tag items',

  // Menu chrome.
  entityActions: 'Entity actions',
  projectActions: 'Project actions',
  propertyOption: '{{property}}: {{option}}',
  actions: 'Actions',
  clear: 'Clear',
  selectedCount: { other: '{{count}} selected' },
  undo: 'Undo',

  // Toasts.
  toastAutoArchiveFailed: 'Could not update auto-archive',
  toastCopied: 'Copied',
  toastCopiedCount: {
    one: 'Copied {{count}} item',
    other: 'Copied {{count}} items',
  },
  toastIdCopied: 'ID copied to clipboard',
  toastLinkCopied: 'Link copied to clipboard',
  toastMovedToTrash: 'Moved to Trash',
  toastMovedCountToTrash: {
    one: 'Moved {{count}} item to Trash',
    other: 'Moved {{count}} items to Trash',
  },
  toastRestoredFromTrash: 'Restored from Trash',
  toastRestoreFromTrashFailed: 'Failed to restore from Trash',
  toastMoveToTrashFailed: 'Failed to move to Trash',
  toastDeleted: 'Deleted',
  toastDeletedCount: {
    one: 'Deleted {{count}} item',
    other: 'Deleted {{count}} items',
  },
  toastDeleteFailed: 'Failed to delete',
  toastDiscardedDrafts: {
    one: 'Draft discarded',
    other: '{{count}} drafts discarded',
  },
  toastDiscardDraftFailed: 'Failed to discard draft',
  toastAddedToFavorites: 'Added to favorites',
  toastAddedCountToFavorites: {
    one: 'Added {{count}} item to favorites',
    other: 'Added {{count}} items to favorites',
  },
  toastAddedSomeToFavorites: {
    one: 'Added {{succeeded}} of {{count}} item to favorites; {{failed}} failed',
    other:
      'Added {{succeeded}} of {{count}} items to favorites; {{failed}} failed',
  },
  toastRemovedFromFavorites: 'Removed from favorites',
  toastRemovedCountFromFavorites: {
    one: 'Removed {{count}} item from favorites',
    other: 'Removed {{count}} items from favorites',
  },
  toastRemovedSomeFromFavorites: {
    one: 'Removed {{succeeded}} of {{count}} item from favorites; {{failed}} failed',
    other:
      'Removed {{succeeded}} of {{count}} items from favorites; {{failed}} failed',
  },
  toastFavoritesUpdateFailed: 'Failed to update favorites',
  toastMuted: 'Muted notifications',
  toastMutedCount: {
    one: 'Muted notifications for {{count}} item',
    other: 'Muted notifications for {{count}} items',
  },
  toastMutedSome: {
    one: 'Muted {{succeeded}} of {{count}} item; {{failed}} failed',
    other: 'Muted {{succeeded}} of {{count}} items; {{failed}} failed',
  },
  toastMuteFailed: 'Failed to mute notifications',
  toastUnmuted: 'Unmuted notifications',
  toastUnmutedCount: {
    one: 'Unmuted notifications for {{count}} item',
    other: 'Unmuted notifications for {{count}} items',
  },
  toastUnmutedSome: {
    one: 'Unmuted {{succeeded}} of {{count}} item; {{failed}} failed',
    other: 'Unmuted {{succeeded}} of {{count}} items; {{failed}} failed',
  },
  toastUnmuteFailed: 'Failed to unmute notifications',
  toastMarkedDone: 'Marked as done',
  toastMarkedDoneCount: {
    one: 'Marked {{count}} item as done',
    other: 'Marked {{count}} items as done',
  },
  toastMarkedDonePartial: {
    one: 'Marked {{completed}} of {{count}} item as done',
    other: 'Marked {{completed}} of {{count}} items as done',
  },
  toastMarkedDonePartialUnsaved: {
    one: 'Marked {{completed}} of {{count}} item as done. Some changes could not be saved.',
    other:
      'Marked {{completed}} of {{count}} items as done. Some changes could not be saved.',
  },
  toastMarkDoneUnsaved:
    'Some changes could not be saved. Undo will reverse the accepted changes.',
  toastMarkDoneFailed: 'Failed to mark as done',
  toastUndoFailed: 'Failed to undo',
  toastMarkedNotDone: 'Marked as not done',
  toastMarkedNotDoneCount: {
    one: 'Marked {{count}} item as not done',
    other: 'Marked {{count}} items as not done',
  },
  toastMarkedNotDonePartial: {
    one: 'Marked {{accepted}} of {{count}} item as not done',
    other: 'Marked {{accepted}} of {{count}} items as not done',
  },
  toastMarkNotDoneFailed: 'Failed to mark as not done',
  toastThreadStaysDone:
    'This thread has no received messages, so it stays done',
  toastThreadsStayDone:
    'These threads have no received messages, so they stay done',
  toastCountNotRestored: { other: '{{count}} could not be restored.' },
  toastNotificationsNotRestored: 'Some notifications could not be restored.',
  toastWithWarnings: '{{message}}. {{warnings}}',
  toastWaitingToSync: '{{message}}, waiting to sync',
  toastMarkedRead: 'Marked as read',
  toastMarkedReadCount: {
    one: 'Marked {{count}} item as read',
    other: 'Marked {{count}} items as read',
  },
  toastMarkReadFailed: 'Failed to mark as read',
  toastMarkedUnread: 'Marked as unread',
  toastMarkedUnreadCount: {
    one: 'Marked {{count}} item as unread',
    other: 'Marked {{count}} items as unread',
  },
  toastMarkUnreadFailed: 'Failed to mark as unread',
  toastMovedToFolder: 'Moved to folder',
  toastMovedCount: {
    one: 'Moved {{count}} item',
    other: 'Moved {{count}} items',
  },
  toastMoveToFolderFailed: 'Failed to move to folder',
  movePickerTitle: {
    one: 'Move {{count}} item to folder',
    other: 'Move {{count}} items to folder',
  },
  movePickerSearch: 'Search folders or name a new one…',
  movePickerOpenInSplit: 'Open in split',
  movePickerCreatedByYou: 'Created by you',
  movePickerSharedWithYou: 'Shared with you',
  movePickerCreate: 'New folder “{{name}}”',
  movePickerLoading: 'Loading folders…',
  movePickerEmpty: 'No folders yet. Type a name to create one.',
  movePickerMoving: 'Moving…',
  movePickerKeyboardHint: '↑ ↓ to choose · Enter to move · Esc to cancel',
  movePickerTouchHint: 'Tap a folder to move here',
  dragMoreItems: {
    one: '+ {{count}} more item',
    other: '+ {{count}} more items',
  },
  dropIntoFolder: {
    one: 'Move {{count}} item to this folder',
    other: 'Move {{count}} items to this folder',
  },
  toastRemovedFromFolder: 'Removed from folder',
  toastRemovedCountFromFolder: {
    one: 'Removed {{count}} item from folder',
    other: 'Removed {{count}} items from folder',
  },
  toastRenamed: 'Renamed',
  toastRenamedCount: {
    one: 'Renamed {{count}} item',
    other: 'Renamed {{count}} items',
  },
  toastRenameFailed: 'Failed to rename',
  toastFolderUpdateFailed: 'Failed to update folder',
  toastCopyFailed: {
    one: 'Unable to copy item',
    other: 'Unable to copy items',
  },
  toastDuplicateFolderFailed: 'Unable to duplicate folder',
  folderDuplicateLimitHint:
    'Folders with more than 100 files, chats, and subfolders can’t be duplicated.',
  toastGithubLinkCopied: 'GitHub link copied to clipboard',
  toastBranchNameCopied: 'Branch name copied to clipboard',
  download: 'Download',
  copyGithubLink: 'Copy GitHub Link',
  prMerge: 'Merge',
  prMerging: 'Merging…',
  prMergeWaitsOnChecksTooltip: 'Merge is available once every check passes',
  prReadyForReview: 'Ready for review',
  prConvertToDraft: 'Convert to draft',
  prClose: 'Close pull request',
  prReopen: 'Reopen pull request',
  prActions: 'Pull request actions',
  prMoreActions: 'More pull request actions',
  toastPrReopened: 'Reopened {{name}}',
  toastPrReopenFailed: 'Failed to reopen pull request',
  toastPrReadyForReview: 'Ready for review: {{name}}',
  toastPrReadyForReviewFailed: 'Failed to mark pull request ready for review',
  toastPrConvertedToDraft: 'Converted to draft: {{name}}',
  toastPrConvertToDraftFailed: 'Failed to convert pull request to a draft',
  toastPrClosed: 'Closed {{name}}',
  toastPrCloseFailed: 'Failed to close pull request',
};
